// Open/dicht, submenu's en Esc komen van pk-theme/assets/js/header.js. Dit voegt alleen de
// sluitknop, de backdrop en de toegankelijkheid van het paneel toe.
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".pk-menu").forEach((nav) => {
		const hamburger = nav.querySelector(".hamburger");
		const panel = nav.querySelector(".menu");
		const closeButton = nav.querySelector("[data-menu-close]");
		const bar = nav.querySelector(".pk-menu-bar");
		if (!hamburger || !panel || !closeButton) return;

		// Alles buiten het paneel: pagina, footer, header-logo en de headerbalk zelf.
		const behind = () => [
			...document.querySelectorAll(".pk-page > :not(header), .pk-header-wrapper > .header-logo"),
			bar,
		];

		nav.querySelectorAll("[data-menu-close], [data-menu-backdrop]").forEach((el) => {
			el.addEventListener("click", () => hamburger.click());
		});

		let wasOpen = false;

		new MutationObserver(() => {
			const open = panel.classList.contains("open");
			if (open === wasOpen) return;
			wasOpen = open;

			behind().forEach((el) => { el.inert = open; });
			(open ? closeButton : hamburger).focus({ preventScroll: true });
		}).observe(panel, { attributes: true, attributeFilter: ["class"] });
	});
});
